<script lang="ts" setup>
import { type PropType } from "vue";

import BaseLayout from "../layouts/base-layout.vue";

import { type LayoutProps } from "../layouts/layouts";

defineProps({
  layout: {
    type: String,
    default: "default",
  },
  layoutProps: {
    type: Object as PropType<LayoutProps>,
    default: () => ({}),
  },
});
</script>

<template>
  <BaseLayout :name="layout" v-bind="layoutProps">
    <slot />
  </BaseLayout>
</template>
